module.exports = __webpack_public_path__ + "img/chek.34dfa52a.svg";